import React from 'react';

const columns = [
  {
    title: 'Subject',
    dataIndex: 'subject',
  },
  {
    title: 'Count',
    dataIndex: 'count',
  },
  {
    title: 'Attachment',
    dataIndex: 'attachmentURL',
  },
  {
    title: 'Email Content',
    dataIndex: 'body',
  },
  {
    title: 'Status',
    dataIndex: 'status',
  },
  {
    title: 'Date',
    dataIndex: 'createdDate',
  },
  {
    title: 'Action',
    dataIndex: 'action',
  },
];

export default columns;